import helpers from '@/helpers/helpers';

export default function FileValidate() {
  function handleFileChange(e) {
    const files = e.target.files;
    const allowedTypes = e.target.accept.split(',');
    for (const file of files) {
      if (allowedTypes.includes(file.type)) continue;

      e.target.value = '';
      helpers.errorToast('Invalid file type');
    }
  }

  return {
    created(el) {
      el.addEventListener('change', handleFileChange);
    },
    unmounted(el) {
      el.removeEventListener('change', handleFileChange);
    },
  };
}
